import type { CartResponse } from '@backmarket/nuxt-layer-checkout/api/cart/types'

export function isCountryShippable(
  country: string | null | undefined,
  shippableCountries: CartResponse['shippableCountries'],
) {
  // When the customer has no pre-defined address (i.e.: new user)
  if (!country) {
    return true
  }

  return shippableCountries.some(({ countryCode }) => countryCode === country)
}
